<template>
  <div v-if="dashboard_page && getProfile.role === 'teacher'" class="w-full relative bg-white h-10 transition-colors duration-300 border-b flex items-center z-10 focus-within:border-gray-300 hover:border-primary">
    <i class="fas fa-search absolute left-4 -translate-y-1/2 text-gray-400" style="top: 13px;"></i>
    <div @click="handleOpenSearch()" class="cursor-pointer select-none flex items-center w-full pl-10 text-gray-400 h-full border-none font-manrope">
      <span>Search by roundtables or courses...</span>
    </div>
  </div>
  <div v-else-if="dashboard_page && getProfile.role === 'student'" class="w-full relative font-manrope px-5 bg-white h-10 border-b flex items-center z-10 focus-within:border-gray-300">
    Hello <span class="ml-1 font-bold text-gray-800">{{user_name}}</span>! Here you can see your most recently used RoundTables.
  </div>
  <div v-else class="bg-white h-10 border-b flex items-center z-20">
    <div class="w-full">
      <h6 v-if="my_courses_page" class="w-full flex items-center justify-between px-5">
        <div class="text-gray-800 font-manrope">
          Hello <span class="font-bold"> {{ user_name }}!</span> Here you can see a list of your courses as an
          <span v-if="is_teacher_mode">instructor</span>
          <span v-else>participant</span>.
        </div>
      </h6>
      <div v-else-if="profile_page" class="px-5">
        <div class="flex items-center space-x-3 cursor-default">
          <span class="font-bold">{{ user_name }}</span>
          <span class="text-xs text-gray-400 font-poppins">{{ userProfile.email }}</span>
        </div>
        <img
          v-if="userProfile.provider === 'google'"
          src="/static/logos/googleLogo.svg"
          alt="Google"
          class="w-3 h-3 ml-2 inline-block"
        />
        <img
          v-else-if="userProfile.provider === 'windowslive'"
          src="/static/logos/msLogo.svg"
          alt="Microsoft"
          class="w-3 h-3 ml-2 inline-block"
        />
      </div>
      <div v-else-if="admin_portal_page" class="flex justify-between w-full px-5">
        <div v-if="getProfile.role === 'admin'" class="flex justify-between w-full">
          <span class="font-bold"> {{ school.name }}</span>
          <button
            v-if="getProfile.role === 'admin'"
            @click="signOutParlay"
            class="text-xl cursor-pointer hover:text-gray-800"
          >
            <i class="fa fa-sign-out"></i>
          </button>
        </div>
        <span v-else class="font-bold"> {{ userProfile.school.name }}</span>
      </div>
      <div v-else-if="support_PD_page" class="px-5">
        <span class="font-bold">Support & PD</span>
      </div>
      <div v-else class="flex justify-between w-full items-center pl-5 pr-2">
        <div v-if="changeHeader" class="flex items-center space-x-3">
          <div class="text-sm text-gray-800 font-bold font-manrope">
            <div v-if="$route.name === 'course.student-reports.summary' || $route.name === 'course.student-reports.discussion'">
              <div v-if="getProfile.is_paid" class="flex items-center space-x-2">
                <img :src="getUserById.avatar_url" class="w-5 h-5 rounded-full">
                <h6>{{ getUserById.name }}</h6>
              </div>
              <div v-else class="flex items-center space-x-2">
                <img src="https://parlay-api.herokuapp.com/api/files/1599763924317-Screen Shot 2020-09-10 at 2.51.47 PM.png" class="w-5 h-5 rounded-full">
                <h6>Angela Ortiz</h6>
              </div>
            </div>
            <div v-else>
              <span>{{ rt_title }}</span>
            </div>
            <span v-if="width < 1300 && rt_title.length > 25" :title="rt_title" class="cursor-pointer text-xs">...</span>
          </div>
          <router-link :to="{ path: `/classes/${courseId}` }">
            <div class="flex items-center space-x-2 truncate">
              <span class="text-xs text-gray-800 hover:underline font-poppins"> {{ courseTitle }}</span>
            </div>
          </router-link>
        </div>
        <div v-else class="flex items-center justify-between space-x-3 truncate">
          <router-link :to="{ path: `/classes/${courseId}` }">
            <span :class="$route.name !== 'course.index' ? 'hover:underline cursor-pointer' : 'cursor-default'" class="text-sm font-bold font-manrope text-gray-800">
              {{ courseTitle }}
            </span>
          </router-link>
          <span class="text-xs cursor-default font-poppins font-light"> {{ sections }} </span>
        </div>
        <div class="flex items-center text-xs space-x-1 text-gray-700">
          <div>
            <button @click="openCloseCourseChat()" class="flex items-center space-x-2 px-3 py-0.5 cursor-pointer hover:bg-gray-100 text-gray-700 hover:text-gray-800 rounded-full">
              <i class="fas fa-comments text-base relative">
                <div v-if="message_notifications > 0" class="absolute top-0 right-0 h-2 w-2 rounded-full bg-pinky"></div>
              </i>
              <span class="font-poppins font-medium">Chat</span>
            </button>
          </div>
          <div>
            <button
              @click="navigateToStudentReports"
              class="flex items-center space-x-2 px-3 py-0.5 hover:bg-gray-100 text-gray-700 hover:text-gray-800 cursor-pointer rounded-full"
              :class="students_report_page ? 'text-primary-dark bg-gray-100' : 'text-gray-700'"
            >
              <i class="fa-solid fa-chart-bar text-base"></i>
              <span class="font-medium font-poppins">Reports</span>
            </button>
          </div>
          <div>
            <button
              @click="navigateToCourseSettings"
              v-if="hasTeacherPermissionsInCourse"
              class="flex items-center space-x-2 cursor-pointer px-3 py-0.5 hover:bg-gray-100 text-gray-700 hover:text-gray-800 rounded-full"
              :class="course_settings_page ? 'text-gray-800 bg-gray-100' : 'text-gray-800'"
            >
              <i class="text-base fas fa-cog"></i>
              <span class="font-poppins font-medium">Settings</span>
            </button>
          </div>
        </div>
      </div>
      <div v-if="show_course_chat" class="px-5">
        <ChatBox
          @message_notifications_val="updateUnreadMessages"
          @close="openCloseCourseChat"
        />
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  /* import courseDetailsService from 'services/courses'; */
  import { EventBus } from 'utils/event-bus';
  import store from 'store';
  export default Vue.extend({
    data() {
      return {
        seeAllTitle: false,
        width: window.innerWidth,
        show_course_chat: false,
        message_notifications: 0,
        studentToShow: {},
        selectedRTOnDiscussionReport: '',
      };
    },
    components: {
      ChatBox: () => import('features/courses/components/courseChatBox.vue'),
      Tooltip: () => import('../../components/Tooltip.vue'),
    },
    props: {
      changeHeader: {
        type: Boolean,
        default: false,
      },
      isSidebarOpened: Boolean,
      scrollTop: undefined,
    },
    computed: {
      ...mapGetters([
        'getProfile',
        'getCourseDetail',
        'hasTeacherPermissionsInCourse',
        'getCurrentRT',
        'getCurrentDiscussion',
        'getStudentsInCourse',
        'getCurrentSchool',
        'getDashboardRole',
      ]),
      userProfile() {
        return this.getProfile;
      },
      courseTitle() {
        return this.getCourseDetail.title;
      },
      courseId() {
        return this.getCourseDetail.id;
      },
      sections() {
        if (this.getCourseDetail.sections && this.getCourseDetail.sections[0])
          return this.getCourseDetail.sections[0];
        return '';
      },
      dashboard_page() {
        return this.$route.name === 'dashboard';
      },
      my_courses_page() {
        return this.$route.name === 'my-courses';
      },
      profile_page() {
        return (
          this.$route.name === 'profile.info' ||
          this.$route.name === 'profile.password' ||
          this.$route.name === 'profile.membership' ||
          this.$route.name === 'profile.integrations' ||
          this.$route.name === 'profile.security'
        );
      },
      course_settings_page() {
        return this.$route.name.includes('course.settings');
      },
      students_report_page() {
        return this.$route.name.includes('course.student-reports.summary');
      },
      admin_portal_page() {
        return this.$route.path.includes('admin-portal');
      },
      support_PD_page() {
        return this.$route.name === 'support_&_PD';
      },
      user_name() {
        return this.getProfile.preferred_name
          ? this.getProfile.preferred_name
          : this.getProfile.name.split(' ')[0];
      },
      getUserById: function () {
        const student = this.getStudentsInCourse.filter(
          (student) => student.id === this.$route.params.studentID
        );
        return student[0];
      },
      courseHasStudents: function () {
        const studentToGo = this.getCourseDetail.users.find((student) => {
          return student.subscription.role === 'student';
        });
        if (studentToGo) return true;
        return false;
      },
      rt_title() {
        return this.$route.params.roundtableID
          ? this.getCurrentRT.title
          : this.getCurrentDiscussion.title;
      },
      school() {
        return this.getCurrentSchool;
      },
      selectedRoundTable: function () {
        return this.getCurrentDiscussion.title;
      },
      is_teacher_mode() {
        return this.getDashboardRole === 'teacher';
      },
    },
    watch: {
      'getCourseDetail.unread_messages': {
        immediate: true,
        handler() {
          this.message_notifications = this.getCourseDetail.unread_messages;
        },
      },
    },
    methods: {
      handleOpenSearch: function() {
        EventBus.$emit('handleOpenSearch');
      },
      navigateToCourseSettings: function () {
        this.$router.push({ name: 'course.settings.general' });
      },
      openCloseCourseChat: function () {
        this.show_course_chat = !this.show_course_chat;
        if (this.show_course_chat) {
          this.$store.dispatch('readCourseMessages', {
            courseID: this.getCourseDetail.id,
          });
        }
      },
      updateUnreadMessages: function (val) {
        this.message_notifications = val;
      },
      studentsWithLastName: function (students_list) {
        let students = [];
        students_list.forEach((item) => {
          const lastName = item.name.split(' ').slice(-1).join(' ');
          item.lastName = lastName;
          students.push(item);
        });
        return students;
      },
      navigateToStudentReports: function () {
        if (this.hasTeacherPermissionsInCourse) {
          if (this.getProfile.is_paid === false) {
            return this.$router.push({
              name: 'course.student-reports.summary',
              params: { studentID: 'demo' },
            });
          }
          const students = this.studentsWithLastName(this.getStudentsInCourse);
          students.sort((a, b) => a.lastName.localeCompare(b.lastName));

          if (students.length === 0) {
            EventBus.$emit('createToast', {type: 'Info', message: 'This course has no students yet.', time: 5000 });
            return;
          }
          return this.$router.push({
            name: 'course.student-reports.summary',
            params: { studentID: students[0].id },
          });
        }
        return this.$router.push({
          name: 'course.student-reports.summary',
          params: { studentID: this.getProfile.id },
        });
      },
      signOutParlay: function () {
        localStorage.removeItem('_prly_tk');
        sessionStorage.removeItem('exactRoute');
        Vue.router.go('login');
      },
      toggleRole(roleToChangeTo) {
        store.dispatch('setDashboardRole', roleToChangeTo);
      },
    },
    mounted: async function () {
      EventBus.$on('selectedRT', (option) => {
        this.selectedRTOnDiscussionReport = option.title;
      });
    },
  });
</script>



// WEBPACK FOOTER //
// theHeader.vue?17c4a098